import { MessageSquare, MessagesSquare, PartyPopper } from 'lucide-react'
import { useState } from 'react'
import { useNotification } from '../contexts/NotificationContext'
import { splitHidden } from '../lib/groupMessages'
import GroupMessageItem from './GroupMessageItem'
import { Button } from './ui/button'

// The one place for group messaging (owner 2026-10-12): owner messages,
// kudos, prize wins and joins, with "Message the Group" and "Give Kudos" in
// its header. Kudos are given per member, so that button jumps to Members.
export default function GroupMessagesTab({
  items,
  hiddenKeys,
  loading,
  onSetHidden,
  isOwner,
  canSendKudos,
  onMessageGroup,
  onGiveKudos,
  formatTimeAgo,
}) {
  const notify = useNotification()
  const [showHidden, setShowHidden] = useState(false)
  const { visible, hidden } = splitHidden(items, hiddenKeys)

  const handleHiddenChange = async (item, nextHidden) => {
    try {
      await onSetHidden(item, nextHidden)
    } catch (err) {
      console.error('Error hiding message:', err)
      notify.error(err.message || 'Could not update this message')
    }
  }

  const renderItem = (item, isHidden) => (
    <GroupMessageItem
      key={item.key}
      item={item}
      hidden={isHidden}
      onHiddenChange={handleHiddenChange}
      formatTimeAgo={formatTimeAgo}
    />
  )

  return (
    <div>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-4">
        <h2 className="text-lg font-semibold flex items-center gap-2">
          <MessagesSquare className="h-5 w-5 text-primary" />
          Messages
        </h2>
        <div className="flex flex-col sm:flex-row gap-2">
          {/* Owner only: send_group_message rejects everyone else. */}
          {isOwner && (
            <Button variant="outline" size="sm" onClick={onMessageGroup}>
              <MessageSquare className="h-4 w-4 mr-2" />
              Message the Group
            </Button>
          )}
          {canSendKudos && (
            <Button variant="outline" size="sm" onClick={onGiveKudos}>
              <PartyPopper className="h-4 w-4 mr-2" />
              Give Kudos
            </Button>
          )}
        </div>
      </div>

      {loading ? (
        <div className="py-8 flex justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
        </div>
      ) : visible.length === 0 ? (
        <div className="text-center py-8 text-muted-foreground">
          <MessagesSquare className="h-12 w-12 mx-auto mb-4 opacity-50" />
          <p>{hidden.length ? 'You have hidden every message' : 'No messages yet'}</p>
        </div>
      ) : (
        <div className="space-y-3">{visible.map((item) => renderItem(item, false))}</div>
      )}

      {hidden.length > 0 && (
        <div className="mt-4">
          <Button variant="ghost" size="sm" onClick={() => setShowHidden((v) => !v)}>
            {showHidden ? 'Hide hidden messages' : `Show ${hidden.length} hidden`}
          </Button>
          {showHidden && (
            <div className="space-y-3 mt-3">{hidden.map((item) => renderItem(item, true))}</div>
          )}
        </div>
      )}
    </div>
  )
}
